import { useState, useEffect } from "react"
import { ArticleData } from "../../../../../articlePage/stateInterfaces"
import { SiteSimpleImage } from "../../../../commonComponents/inline/siteSimpleImage"
import { secondsToMinutes } from "../../../../siteWidgets/siteWidgetUtils"
import { PodcastPlayer } from "../../../radioWidgets/floatingPlayer/podcastPlayerButton"
import { DateDisplay } from "../../../../commonComponents/inline/dateDisplay/dateDisplay"
import { SiteArticleSocialShareNew1280 } from "../../../article/componentas/articleSocialShare1280Component/articleSocialShareNew1280"
import { SignUpForPodcast } from "../../../radioWidgets/articleAudioPodcast/components/signupForPodcast"
import { ArticleAppHeaderShareComponent } from "../../../article/componentas/articleHeaderComponenta/articleAppHeaderShareComponent"
import { ArticleImageSlider } from "../../../calcalistWidgets/articleImageGallery/components/articleImageSlider"
import { imageListGalleryCalcalist } from "../../../calcalistWidgets/articleImageGallery/components/articleImageSliderEditor"

interface AudioPodcastPlayerProps {
    title: string
    subTitle?: string
    category: string
    categoryId?: string
    audioUrl: string
    durationSeconds: number
    imageUrl: string
    isMobileWeb?: boolean
    articleLink?: string
    articleData?: ArticleData
    description?: string
    publishedDate?: Date
    authorName?: string
    isApp?:boolean
    shouldAudioGalleryDisplay?:boolean
    imageList?:imageListGalleryCalcalist[]
}


declare const window: Window & {
    shouldAudioAutoplay?: boolean;
}


export const AudioBepoPodcastPlayer = (props: AudioPodcastPlayerProps) => {
    const [showDescription, setShowDescription] = useState(false)
    const { imageList, title, subTitle, category, categoryId, audioUrl, durationSeconds, imageUrl, isMobileWeb, isApp, articleLink, description, publishedDate, authorName, shouldAudioGalleryDisplay } = props

    const podcastDuration = secondsToMinutes(durationSeconds, "דק'");
    const browserDisplayMediaMetaData = { title: title, artist: "Bepo", album: category }
    const openPodcastPlayer = (id: string) => {
        window.location.href = `//podcast/${id}`
    }
    const shouldAudioAutoplay = typeof window !== "undefined" && window.shouldAudioAutoplay;
   const toggleShowDescription = () => {
    const {isMobileWeb, isApp} = props
       setShowDescription(!showDescription);
       getClickedBtnText(showDescription ? "צמצום" : "קראו עוד");
        const element = document.querySelector(".podcast-text.collapsed")
       if(element && (isMobileWeb || isApp)){
           element.scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"});
       }
   }
    const getClickedBtnText = (text) => {
        if (typeof window != "undefined" && window.Android) {
            window.Android.onClickTextChange(text)
        }
        if (typeof window != "undefined" && window.webkit && window.webkit.messageHandlers) {
            window.webkit.messageHandlers.onClickTextChange.postMessage(text);
        }
    }
    useEffect(() => {
        isApp && shouldAudioAutoplay && openPodcastPlayer(props.articleData.articleId);
    }, [isApp, props.articleData.articleId]);

    const scriptObj = {
        id: props.articleData.articleId,
        name: authorName,
        title: title,
        durationSeconds: durationSeconds,
        imageUrl: imageUrl,
        audioUrl: audioUrl,
        articleLink: articleLink
    };
    const scriptString = `window.podcastsData = window.podcastsData || {};
        window.podcastsData["${props.articleData.articleId}"] = ${JSON.stringify(scriptObj)};`
    return (
        <div className="audio-podcast-player-bepo">
            <div className="audio-podcast-player-container">
                <div className="podcast-image">
                    <SiteSimpleImage src={imageUrl} />
                    {isApp ? <div className="podcastPlayBtnContainer">
                        <a className="podcastPlayBtn" href={`//podcast/${scriptObj.id}`} ></a>
                        <script type="text/javascript" dangerouslySetInnerHTML={{ __html: scriptString }} />
                    </div> : <PodcastPlayer
                        audioUrl={audioUrl}
                        title={title}
                        isMobileWeb={isMobileWeb}
                        className="audio-play-button-bepo"
                        durationSeconds={durationSeconds}
                        browserDisplayMediaMetaData={browserDisplayMediaMetaData}
                        articleLink={articleLink}
                        articleData={props.articleData}
                        rangeThumbColor={"#DF3232"}
                        rangeColor={"#BBBBBB"}
                        rangeProgressColor={"#DF3232"}
                        shouldAudioAutoplay={shouldAudioAutoplay}
                    />}
                    <SignUpForPodcast className="bepo" categoryId={categoryId} />
                </div>
                <div className="podcast-container-details">
                    <div className="podcast-title">{title}</div>
                    <div className="podcast-subtitle">{subTitle}</div>
                    <div className="podcast-details">
                        <span className="duration">{podcastDuration}</span>
                        <span className="publishedDate">פורסם <DateDisplay date={publishedDate} /></span>
                       {isApp ?<ArticleAppHeaderShareComponent isMagazineArtice={true} showComments={false} /> : <SiteArticleSocialShareNew1280
                            categorySubChannel={""}
                            author={""}
                            articleId={""}
                            isBottomButtons={false}
                            showComments={false}
                            isMobile={false}
                            isSpotim={false}
                            lang={"he"}
                            audioArticle={true} /> }
                        {(description ||shouldAudioGalleryDisplay)  && <button className={isApp ? 'toggle-description-pf':`toggle-description`} onClick={toggleShowDescription}>
                            <span className="toggle-desc-text-pf">{showDescription ? "צמצום" : "קראו עוד"}</span>
                            <span className={`${isApp ? 'icon-pf' : 'icon'} ${showDescription ? "expanded" : "collapsed"}`} />
                        </button>}
                    </div>

                </div>


                {(description ||shouldAudioGalleryDisplay) && <div className={`podcast-text ${showDescription ? "expanded" : "collapsed"}`}>
                    <span>{description}</span>
                    {shouldAudioGalleryDisplay &&    <div className={"AudioMediaGallery"} id="AudioMediaGallery">           
                                         <ArticleImageSlider imageSliderWidth={"unset"} imageList={imageList} infinite={false} width={"auto"} height={"auto"} style={{background:"transparent" }}/>                             
                             </div>
                    }
                    </div>}
            </div>


        </div>
    )
}
AudioBepoPodcastPlayer.siteScriptName = "AudioBepoPodcastPlayer"